import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import { Stack, Typography } from '@mui/material';
import { confidenceColor } from '../lib/fieldGroups';

interface ConfidenceBadgeProps {
  confidence: number | null;
}

export const ConfidenceBadge = ({ confidence }: ConfidenceBadgeProps) => {
  const score = confidence ?? 0;
  const color = confidenceColor(score);
  const Icon = score >= 0.65 ? CheckCircleIcon : WarningIcon;

  return (
    <Stack direction="row" spacing={0.5} alignItems="center" sx={{ minWidth: 56, flexShrink: 0 }}>
      <Icon sx={{ fontSize: 16, color }} />
      <Typography variant="caption" sx={{ color }}>
        {Math.round(score * 100)}%
      </Typography>
    </Stack>
  );
};
